import { Adapter } from "@/core/models/adapter";

export class Response {
  constructor() {
    this.id = null;
    this.responseId = null;
    this.questionId = null;
    this.responseLabel = null;
    this.responseState = null;
    this.question = null;
    this.nameAnsweredBy = null;
    this.questionType = null;
    this.typeUserAnsweredBy = null;
    this.typeOrganizationAnsweredBy = null;
    this.warehouseId = null;
    this.comment = null;
    this.updatedBy = null;
    this.createdBy = null;
    this.createdAt = null;
    this.updatedAt = null;
    this.organizationId = null;
  }
}

export class ResponseAdapter extends Adapter {
  static adapt(responseApi) {
    const response = new Response();
    response.id = responseApi?.id;
    response.responseId = responseApi?.responseId;
    response.questionId = responseApi?.questionId;
    response.responseLabel = responseApi?.responseLabel;
    response.responseState = responseApi?.responseState;
    response.question = responseApi?.question;
    response.nameAnsweredBy = responseApi?.nameAnsweredBy;
    response.questionType = responseApi?.questionType;
    response.typeUserAnsweredBy = responseApi?.typeUserAnsweredBy;
    response.typeOrganizationAnsweredBy = responseApi?.typeOrganizationAnsweredBy;
    response.warehouseId = responseApi?.warehouseId;
    response.itemDiagnostic = responseApi?.itemDiagnostic;
    response.comment = responseApi?.comment;
    response.diagnosticType = responseApi?.diagnosticType;
    response.updatedBy = responseApi?.updatedBy;
    response.createdBy = responseApi?.createdBy;
    response.createdAt = responseApi?.createdAt;
    response.updatedAt = responseApi?.updatedAt;
    response.organizationId = responseApi?.organizationId;

    return response;
  }
}
